<template lang='pug'>
button.dropdown.relation-dropdown(
  @click.prevent='openDropdown'
  :style="select ? 'text-align: left;' : ''")
  .dropdown-toggle(data-toggle="dropdown" )
    img.img-add(src='../../assets/images/faces/ic_add_24px.svg' v-if='!select')
    span(:style="select ? 'margin-left: 0; color:#4B2D15; font-size:12px;' : ''") {{ selectedValue }}
    .material-icons(v-if="select") signal_cellular_4_bar
    ul.dropdown-menu.relation-dropdown-menu
      li.li-relation-add(v-for="r in relations")
        a.dropdown-item.relation-dropdown-item(href="" @click="changeValue(r.code)") {{ r.name }}
</template>
<script>
import $ from 'jquery'
import MdNotification from '@/core/components/mdNotification'
export default {
  components: {MdNotification},
  props: {
    objSelected: Object
  },
  data() {
    return {
      relations: [
        { code: 3, name: 'Giáo viên' },
        { code: 1, name: 'Bạn bè' },
        { code: 2, name: 'Bạn đồng hành' }
      ],
      selectedValue: 'Thêm bạn',
      select: false
    }
  },
  methods: {
    openDropdown(event) {
      var dropdown = $(event.target).closest('.relation-dropdown')
      if (!dropdown.hasClass('open')) {
        $('.relation-dropdown').removeClass('open')
        dropdown.addClass('open')
      } else {
        dropdown.removeClass('open')
      }
    },
    changeValue(code) {
      for (let i = 0; i < this.relations.length; i++) {
        if (this.relations[i].code === code) {
          this.selectedValue = this.relations[i].name
          this.select = true
          var data = {
            value: this.relations[i],
            sender: {id: this.objSelected.id, fullname: this.objSelected.fullname}
          }
          this.$emit('onChangeValue', data)
          break
        }
      }
    }
  },
  mounted () {
    // console.log('===== mounted =====')
    if (this.objSelected && this.objSelected !== null) {
      for (let i = 0; i < this.relations.length; i++) {
        if (this.relations[i].code === this.objSelected.type) {
          this.selectedValue = this.relations[i].name
          this.select = true
          break
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
button.relation-dropdown {
  background: #FBF4D2;
  box-shadow: none;
  color: #9F6A28;
  border: 1px solid #FBF4D2;
  border-radius: 5px;
  height: 32px;
  width: calc(100% - 15px);
  font-size: 12px;
  cursor: pointer;
  &:hover {background: #f9eebb; color: #9F6A28;}
  .dropdown-toggle {
    white-space: nowrap;
    span {margin-left: 10px;font-size: 12px;}
    .img-add {width: 20px;}
    .material-icons {
      transform: rotate(45deg);
      position: absolute;
      top: 7px;
      right: 5px;
      color: black;
      font-size: 10px;
    }
    ul.relation-dropdown-menu {
      min-width: 112px !important;
      padding: 0;
      width: 100%;
      li.li-relation-add {
        a.relation-dropdown-item {
          margin: 0;
          padding: 10px 5px;
        }
      }
    }
  }
}
@media (max-width: 767px) {
  button.relation-dropdown {
    .dropdown-toggle {
      ul.relation-dropdown-menu {
        // display: block;
      }
    }
  }
}
@media (max-width: 414px) {
  button.relation-dropdown {
    .dropdown-toggle {
      span {margin-left: 0}
    }
  }
}
</style>



// WEBPACK FOOTER //
// dropdown.vue?70523342